export const esConfig: Partial<InitOptions> = {
  businessName: 'Soporte en vivo',
  locale: 'es',
  customText: {
    clickToRetry: 'Mensaje no enviado. Pulsa para reintentar.',
    clickToRetryForm:
      'Formulario no enviado. Pulsa en cualquier lugar del formulario para reintentarlo.',
    conversationTimestampHeaderFormat: 'DD MMMM YYYY, h:mm A',
    couldNotConnect: 'Desconectado. No recibirás mensajes.',
    couldNotConnectRetry: 'Reconectando...',
    couldNotConnectRetrySuccess: '¡Vuelves a estar en línea!',
    couldNotLoadConversations: 'No se pueden cargar las conversaciones.',
    fetchHistory: 'Cargar más',
    fetchingHistory: 'Recuperando historial...',
    fileTooLargeError: 'Tamaño máximo de archivo superado ({size})',
    fileTypeError: 'Tipo de archivo no compatible.',
    formErrorInvalidEmail: 'Correo electrónico no válido',
    formErrorNoLongerThan: 'Debe contener no más de ({characters}) caracteres',
    formErrorNoShorterThan: 'Debe contener al menos ({characters}) caracteres',
    formErrorUnknown: 'Esto no parece correcto del todo',
    formFieldSelectPlaceholderFallback: 'Elige uno...',
    headerText: '¿Cómo podemos ayudarte?',
    imageClickToReload: 'Pulsa para recargar la imagen.',
    imageClickToView: 'Pulsa para ver {size} imagen.',
    imagePreviewNotAvailable: 'Previsualización no disponible',
    inputPlaceholder: 'Escribe un mensaje...',
    inputPlaceholderBlocked: 'Completa el formulario de arriba...',
    messageError:
      'Se ha producido un error al enviar tu mensaje. Por favor, inténtalo de nuevo',
    messageIndicatorTitlePlural: '({count}) Nuevos mensajes',
    messageIndicatorTitleSingular: '({count}) Nuevo mensaje',
    messageRelativeTimeDay: 'hace {value}d',
    messageRelativeTimeHour: 'hace {value} hora',
    messageRelativeTimeJustNow: 'Justo ahora',
    messageRelativeTimeMinute: 'hace {value} minuto',
    messageTimestampFormat: 'h:mm A',
    messageDelivered: 'Enviado',
    messageSeen: 'Visto',
    messageSending: 'Enviando...',
    messageTooLongError: 'Tamaño máximo de archivo superado ({size})',
    sendButtonText: 'Enviar',
    tapToRetry: 'Mensaje no enviado. Pulsa para reintentar.',
    tapToRetryForm:
      'Formulario no enviado. Pulsa en cualquier lugar del formulario para reintentar.',
    uploadDocument: 'Archivo',
    uploadInvalidError: 'Archivo no válido',
    uploadPhoto: 'Imagen',
    uploadVirusError:
      'Un virus se ha detectado en tu archivo y se ha rechazado',
  },
};
